import { Component, OnInit, Input } from '@angular/core';
import {
  faAt, faBookReader, faCalendarDay, faCoffee, faCoins, faEnvelopeOpenText, faFax, faFile,
  faFileInvoiceDollar, faFileSignature, faHandHolding, faHome, faHouse, faHouseUser, faIdCard,
  faPencilAlt, faPhone, faSearchLocation, faSign, faSms, faTasks, faUserInjured, faUserTie, faEye,
  faListOl, faClipboard, faDoorClosed, faEdit, faMoneyCheckAlt, faWallet, faArrowToLeft, faPause, faPlay, faPoundSign, faFileInvoice,
  faArrowRight, faArrowLeft, faCrown, faCommentAltCheck, faUserCheck, faPiggyBank, faUserAlt
} from '@fortawesome/pro-light-svg-icons';
import { AdhocLetterComponent } from '../adhoc-letter/adhoc-letter.component';
import { EmailComponent } from '../email/email.component';
import { FaxComponent } from '../fax/fax.component';
import { PhonecallComponent } from '../phonecall/phonecall.component';
import { SmsComponent } from '../sms/sms.component';
import { KeyDatesComponent } from '../key-dates/key-dates.component';
import { CaseNotesComponent } from '../case-notes/case-notes.component';
import { CaseOverviewComponent } from '../case-overview/case-overview.component';
import { PresubmissionChecklistComponent } from '../presubmission-checklist/presubmission-checklist.component';
import { PreexchangeChecklistComponent } from '../preexchange-checklist/preexchange-checklist.component';
import { MortgageDetailsComponent } from '../mortgage-details/mortgage-details.component';
import { EquityReleasePropertyDetailsComponent } from '../property-details/equity-release-property-details/equity-release-property-details.component';
import { EquityReleasePurchasePropertyDetailsComponent } from '../property-details/equity-release-purchase-property-details/equity-release-purchase-property-details.component';
import { ConveyancingSalePropertyDetailsComponent } from '../property-details/conveyancing-sale-property-details/conveyancing-sale-property-details.component';
import { InvoiceComponent } from '../invoicing/invoice/invoice.component';
import { BrokerDetailsComponent } from '../broker-details/broker-details.component';
import { EquityReleasePurchaseEstateAgentDetailsComponent } from '../estate-agent-details/equity-release-purchase-estate-agent-details/equity-release-purchase-estate-agent-details.component';
import { ConveyancingSaleEstateAgentDetailsComponent } from '../estate-agent-details/conveyancing-sale-estate-agent-details/conveyancing-sale-estate-agent-details.component';
import { LettersComponent } from '../letters/letters.component';
import { CaseService } from 'src/app/shared/services/case.service';
import { ConveyancingPurchasePropertyDetailsComponent } from '../property-details/conveyancing-purchase-property-details/conveyancing-purchase-property-details.component';
import { ConveyancingPurchaseEstateAgentDetailsComponent } from '../estate-agent-details/conveyancing-purchase-estate-agent-details/conveyancing-purchase-estate-agent-details.component';
import { CaseFundsComponent } from '../case-funds/case-funds.component';
import { PreInvoiceFeesComponent } from '../pre-invoice-fees/pre-invoice-fees.component';
import { BankDetailsComponent } from '../bank-details/bank-details.component';
import { environment } from 'src/environments/environment';
import { OnHoldComponent } from 'src/app/on-hold/on-hold.component';
import { OffHoldComponent } from 'src/app/off-hold/off-hold.component';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { EnquiriesChecklistComponent } from '../enquiries-checklist/enquiries-checklist.component';
import { TransactionsComponent } from '../transactions/transactions.component';
import { KlyantService } from 'src/app/shared/services/klyant.service';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { InvoiceListComponent } from '../invoicing/invoice-list/invoice-list.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CaseTaskListComponent } from 'src/app/tasks/case-task-list/case-task-list.component';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';

@Component({
  selector: 'app-case-sidebar',
  templateUrl: './case-sidebar.component.html',
  styleUrls: ['./case-sidebar.component.scss']
})
export class CaseSidebarComponent implements OnInit {

  @Input() caseId?: number;
  @Input() caseData?: any;

  klyantDetails: any = [];

  faCoffee = faCoffee;
  faPhone = faPhone;
  faSms = faSms;
  faAt = faAt;
  faEnvelopeOpenText = faEnvelopeOpenText;
  faFax = faFax;

  faHome = faHome;
  faSearchLocation = faSearchLocation;
  faPencilAlt = faPencilAlt;
  faIdCard = faIdCard;
  faCalendarDay = faCalendarDay;
  faTasks = faTasks;
  faHouseUser = faHouseUser;
  faSign = faSign;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faCoins = faCoins;
  faHouse = faHouse;
  faHandHolding = faHandHolding;
  faFile = faFile;
  faFileSignature = faFileSignature;
  faBookReader = faBookReader;
  faUserTie = faUserTie;
  faUserInjured = faUserInjured;
  faEye = faEye;
  faListOl = faListOl;
  faClipboard = faClipboard;
  faDoorClosed = faDoorClosed;
  faEdit = faEdit;
  faMoneyCheckAlt = faMoneyCheckAlt;
  faWallet = faWallet;
  faArrowToLeft = faArrowToLeft;
  faPause = faPause;
  faPlay = faPlay;
  faCrown = faCrown;
  faCommentAltCheck = faCommentAltCheck;
  faUserCheck = faUserCheck;
  faPoundSign = faPoundSign;
  faFileInvoice = faFileInvoice;
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  faPiggyBank = faPiggyBank;
  faUserAlt = faUserAlt;

  constructor(
    private caseService: CaseService,
    private correspondenceTimelineService: CorrespondenceTimelineService,
    private klyantService: KlyantService,
    private invoiceService: InvoiceService,
    private modalService: ModalService) {

  }

  ngOnInit() {
    //this.loadKlyantDetails();
  }
  openEmail() {
    const modalRef = this.modalService.openWithOptions(EmailComponent, { windowClass: 'emailModal', scrollable: true});
    modalRef.componentInstance.caseId = this.caseId;
  }

  openPhone() {

    const modalRef = this.modalService.openWithOptions(PhonecallComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseData.caseTypeId
  }

  openSms() {

     const modalRef = this.modalService.openWithOptions(SmsComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.optedIn = this.caseData.partyOneCorrespondenceSMS;
  }

  openAdhocLetter() {

    const modalRef = this.modalService.openWithOptions(AdhocLetterComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;

  }

  openFax() {

    const modalRef = this.modalService.openWithOptions(FaxComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
  }

  openKeyDates() {


    const modalRef = this.modalService.openWithOptions(KeyDatesComponent, {size: 'lg', scrollable: true});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.readOnly= this.caseData.isCancelled || this.caseData.onHold;
    modalRef.componentInstance.caseTypeId = this.caseData.type.id;

    modalRef.result.then(
      (result) => {
       if(result)
       {
          if (result == "fileClosed")
            window.location.reload();
       }
    },
    () => {} // dismissed - do nothing
    );  

  }

  openEstateAgent() {

    if (this.caseData.type.id == 6)
    {
       const modalRef = this.modalService.openLgModal(ConveyancingSaleEstateAgentDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }
    else if (this.caseData.type.id == 7)
    {
       const modalRef = this.modalService.openLgModal(EquityReleasePurchaseEstateAgentDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }
    else if (this.caseData.type.id == 8)
    {
       const modalRef = this.modalService.openLgModal(ConveyancingPurchaseEstateAgentDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }

  }

  openBrokerDetails() {

    const modalRef = this.modalService.openWithOptions(BrokerDetailsComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;
  }

  openCaseOverview() {

    const modalRef = this.modalService.openWithOptions(CaseOverviewComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    
  }

  openCaseNotes() {

    const modalRef = this.modalService.openWithOptions(CaseNotesComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;

  }

  openSearches() {
    window.open(
      "https://go.searchflow.co.uk/auth/login");
  }

  openIDCheck() {
    window.open(
      "https://go.searchflow.co.uk/auth/login");
  }

  openClientDetails(){
    alert('TODO');
  }

  openPropertyDetails() {

    if (this.caseData.type.id == 1)
    {
      const modalRef = this.modalService.openXLModal(EquityReleasePropertyDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }
    else if (this.caseData.type.id == 6)
    {
      const modalRef = this.modalService.openXLModal(ConveyancingSalePropertyDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }
    else if (this.caseData.type.id == 7)
    {
      const modalRef = this.modalService.openXLModal(EquityReleasePurchasePropertyDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }
    else if (this.caseData.type.id == 8)
    {
      const modalRef = this.modalService.openXLModal(ConveyancingPurchasePropertyDetailsComponent);
       modalRef.componentInstance.caseId = this.caseId;
    }


  }

  openMortageDetails() {

    const modalRef = this.modalService.openLgModal(MortgageDetailsComponent);
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseOnHold = this.caseData.onHold;

  }

  openPresubmissionChecklist() {

    const modalRef = this.modalService.openXLModal(PresubmissionChecklistComponent);
    modalRef.componentInstance.caseId = this.caseId;
  }

  openPreexchangeChecklist() {
    const modalRef = this.modalService.openXLModal(PreexchangeChecklistComponent);
    modalRef.componentInstance.caseId = this.caseId;
  }

  openInvoicing(){

    this.invoiceService.getInvoices(this.caseId).subscribe((response : any) => {
      var invoices = response.invoices;
      if(invoices.length == 0)
      {
        if(this.caseData.type.id == 1 || // Equity Release
        this.caseData.type.id == 6 || // Conveyancing Sale
        this.caseData.type.id == 7 || // Equity Release Including Purchase
        this.caseData.type.id == 8)	// Conveyancing Purchase
        {

            const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg'});
                  
            modalRef.componentInstance.messageHeader = 'Are all property details completed?';

            modalRef.result.then(
              (result) => {
                if (result) {
                  this.invoiceService.addInvoice( this.caseId, "Client Invoice" ).subscribe((response : any) => {
                    this.openInvoiceScreen(response.invoice.id);
                  });
                }
            },
            () => {} // dismissed - do nothing
          );
        }
        else{
          this.invoiceService.addInvoice( this.caseId, "Client Invoice" ).subscribe((response : any) => {
            this.openInvoiceScreen(response.invoice.id);
          });
        }        
      }
      else if (invoices.length == 1)
      {
        this.openInvoiceScreen(invoices[0].id);
      }
      else if (invoices.length > 1)
      {
        this.openInvoiceList();
      }

    });

  }

  openInvoiceList() {

    const modalRef = this.modalService.openWithOptions(InvoiceListComponent, { size: 'xl'});                  
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseData.type.id;
  }

  openInvoiceScreen(invoiceId: number){

    const modalRef = this.modalService.openWithOptions(InvoiceComponent, { windowClass: 'modal-xxl' });
                    
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.invoiceId = invoiceId;
    modalRef.componentInstance.caseTypeId = this.caseData.type.id;
  }

  openInvoice() {

      // For ER, ER Purchase, Purchase and Sales cases - prompt user to check property details on the first load
      if(this.caseData.type.id == 1 || // Equity Release
      this.caseData.type.id == 6 || // Conveyancing Sale
      this.caseData.type.id == 7 || // Equity Release Including Purchase
      this.caseData.type.id == 8)	// Conveyancing Purchase
      {
        this.invoiceService.getInvoiceId(this.caseId).subscribe((response : any) => {
          if(response.invoiceId == 0 )   
          {

              const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg'});
                    
              modalRef.componentInstance.messageHeader = 'Are all property details completed?';

              modalRef.result.then(
                (result) => {
                  if (result) {
                    this.launchInvoiceScreen();
                  }
              },
              () => {} // dismissed - do nothing
            );
          }
          else{
            this.launchInvoiceScreen();
          }
    
        });
      }
      else{
        this.launchInvoiceScreen();
      }
  }

  launchInvoiceScreen(){

    const modalRef = this.modalService.openWithOptions(InvoiceComponent, { size: 'xl'});           
    modalRef.componentInstance.caseId = this.caseId;
  }

  openCaseTasks() {
    
    const modalRef = this.modalService.openLgModal(CaseTaskListComponent);
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.tasksFor = "case" ;
    
  }

  openCreateLetters() {

    const modalRef = this.modalService.openLgModal(LettersComponent);
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseData.type.id;
  }

  openCaseFunds() {

    const modalRef = this.modalService.openWithOptions(CaseFundsComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseData.type.id;
  }

  openPreInvoiceFees() {

    const modalRef = this.modalService.openXLModal(PreInvoiceFeesComponent);           
    modalRef.componentInstance.caseId = this.caseId;
 
  }

  openBankDetails() {

    const modalRef = this.modalService.openWithOptions(BankDetailsComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
  }

  openPortal1Case() {

    window.open(
      environment.portal1Url + '/case/' + this.caseId, "_self");

  }
  openEnquiriesChecklist() {

    const modalRef = this.modalService.openLgModal(EnquiriesChecklistComponent);
    modalRef.componentInstance.caseId = this.caseId;
  }

  offHoldCase() {
    const modalRef = this.modalService.openWithOptions(OffHoldComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
       if(result)
       {
            window.location.reload();
       }
    },
    () => {} // dismissed - do nothing
    );  
  }

  putCaseOnHold() {

    const modalRef = this.modalService.openWithOptions(OnHoldComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
        (result) => {
          if(result)
          {
           this.correspondenceTimelineService.refreshCaseTimeline.next();
            this.caseService.refreshCaseOverview.next();
            window.location.reload();
      }
    },
      () => {} // dismissed - do nothing
    );

  }

  openHMRCSDLTLink() {
    window.open("https://www.gov.uk/sdlt-online", "_blank");
  }

  openTransactions() {

    const modalRef = this.modalService.openXLModal(TransactionsComponent);
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseData.typeId;
    
  }

  public loadKlyantDetails () {
    this.klyantService.getKlyantDetails(this.caseId).subscribe(response => {
      this.klyantDetails = response;      
    });
  }

}
